import { render, staticRenderFns } from "./Passo3.vue?vue&type=template&id=392db1cc&"
import script from "./Passo3.vue?vue&type=script&lang=js&"
export * from "./Passo3.vue?vue&type=script&lang=js&"
import style0 from "./Passo3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports